import React, { useEffect, useState } from "react";

/**
 * The main application uses these four components
 */
import Header from "./Header";
import Palette from "./Palette";
import Grid from "./Grid";
import ActionPanel from "./ActionPanel";
// import Sound from "react-sound";
// import Sabotage from "./Sabotage.mp3";

/**
 * We need access to COLORS and buildCellList for our initial
 * state objects
 */
import { buildCellList } from "../utils";

const getCellListFromLocal = () => {
  let cellList = JSON.parse(localStorage.getItem("cellList"));
  if (cellList) {
    return cellList;
  }
  return buildCellList();
};
const setCellListOnLocal = (cellList) => {
  localStorage.setItem("cellList", JSON.stringify(cellList));
};

/**
 * The App component represents our entire application. It contains all of the
 * top level components, and is responsible for helping its children communicate
 * with each other via state objects, and state functions.
 */
const App = () => {
  /**
   * Using useState you need to create:
   *
   * - activeColor, setActiveColor initialized to COLORS[0]
   * - cellList, setCellList initialized to buildCellList()
   */ const ColorList = [
    "red",
    "aqua",
    "yellow",
    "limegreen",
    "blue",
    "magenta",
    "gold",
    "black",
  ];

  const [Colors, setColors] = useState(ColorList);
  const [activeColor, setActiveColor] = useState(Colors[0]);
  const [cellList, _setCellList] = useState([]);
  const setCellList = (newCellList) => {
    setCellListOnLocal(newCellList);
    _setCellList(newCellList);
  };

  useEffect(() => {
    setCellList(getCellListFromLocal());
  }, []);

  return (
    <div className="app">
      <h1 class={"footer"}>Enjoy!</h1>
      {/* Header needs no props */}
      <Header />
      {/* Palette needs to be passed activeColor and setActiveColor */}
      <Palette
        activeColor={activeColor}
        setActiveColor={setActiveColor}
        Colors={Colors}
      />

      {/* Grid needs to be passed activeColor, cellList, and setCellList */}
      <Grid
        activeColor={activeColor}
        cellList={cellList}
        setCellList={setCellList}
        Colors={Colors}
      />
      {/* ActionPanel needs to be passed activeColor, cellList, and setCellList */}
      <ActionPanel
        activeColor={activeColor}
        cellList={cellList}
        setCellList={setCellList}
        GridColorList={Colors}
        onUpdateColorList={setColors}
      />
      {/* 
      <Sound
        url="./Sound/Sabotage.mp3"
        playStatus={Sound.status.PLAYING}
        playFromPosition={300}
      /> */}
    </div>
  );
};
export default App;
